import React, { type JSX } from 'react';
import {Button} from "@mui/material";
import {fetchDownloadFile} from "../../../util/FileUtils";
import DownloadCsvIcon from "../../icons/DownloadCsvIcon";
import {getErrorMessageForFileDownloads} from "../../../util/NetworkErrorUtil";
import {useSnackbar} from "../../../context/snackbar-context";

type DownloadCSVButtonProps = {
    title?: string,
    reportUrl: string,
    onError?: (event: Error) => void,
    className?: string | undefined,
    disabled?: boolean,
};

const DownloadCSVButton: (props: DownloadCSVButtonProps) => JSX.Element = ({
    title,
    reportUrl,
    onError,
    className,
    disabled = false,
}) => {
    const { snackbarShowMessage } = useSnackbar();

    const handleError = (error: Error) => {
        if (onError) {
            onError(error);
        } else {
            snackbarShowMessage(getErrorMessageForFileDownloads(error), 'error');
        }
    };

    const handleClick = async () => {
        fetchDownloadFile(reportUrl, undefined, handleError);
    };

    return (
        <Button
            variant={"contained"}
            startIcon={<DownloadCsvIcon/>}
            onClick={handleClick}
            className={className}
            disabled={disabled}
        >
            {title || "Download"}
        </Button>
    );
};

export default DownloadCSVButton;
